import { Skeleton } from '@mui/material';

const FlagSkeleton = () => {
  return <Skeleton variant="rounded" width="100%" height="30rem" />;
};

export default FlagSkeleton;
